import { render, staticRenderFns } from "./fale-com-a-gente-container.vue?vue&type=template&id=1d89b28e&"
import script from "./fale-com-a-gente-container.vue?vue&type=script&lang=ts&"
export * from "./fale-com-a-gente-container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d89b28e')) {
      api.createRecord('1d89b28e', component.options)
    } else {
      api.reload('1d89b28e', component.options)
    }
    module.hot.accept("./fale-com-a-gente-container.vue?vue&type=template&id=1d89b28e&", function () {
      api.rerender('1d89b28e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fale-com-a-gente/fale-com-a-gente-container.vue"
export default component.exports